import { DxPopupComponent } from 'devextreme-angular';
import { ModalWindowComponent } from './modal-window.component';

export enum ModalWindowUserAction {
  apply = 'apply',
  abort = 'abort',
  skip = 'skip',
}

export interface ModalWindowActionPayload {
  modalId: string;
  type: ModalWindowUserAction;
  component?: DxPopupComponent;
  modalWindow?: ModalWindowComponent;
}

export enum ModalWindowModals {
  reassignAgentManagerModal = 'reassignAgentManagerModal',
  reassignAgencyManagerModal = 'reassignAgencyManagerModal',
  manageAgentTeammates = 'manageAgentTeammates',
}
